// extracted by mini-css-extract-plugin
export var badge = "_vg-4";
export var selected = "_vg-1";
export var selectedOverlay = "_vg-5";
export var thumbnailButton = "_vg-0";
export var thumbnailFallback = "_vg-3";
export var thumbnailImage = "_vg-2";